// extracted by css-extract-rspack-plugin
var _1 = "wz4Qq8yq1EAS54us";
var _2 = "wz4Qq8yq1EAS54us";
var _3 = "YeGUe3wV0Y4S_JDh";
var _4 = "sxTqbrkNiRsnXep6";
export { _1 as "competition-logo", _2 as "competitionLogo", _3 as "items", _4 as "wrapper" }
